import {MultiLang} from '../../../../admin/models/multiLang';

export class Cato {

  public id: number;

  public nameKz: string;
  public nameRu: string;
  public name: string;

  public fullNameKz: string;
  public fullNameRu: string;
  public fullName: string;

  public shortNameKz: string;
  public shortNameRu: string;
  public shortName: string;

  public region: MultiLang;
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/cato/cato.ts